var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20.001,
    viewBox: "0 -3 23 23.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_1",
    "data-name": 1,
    d: "M-13436.729,20a3.306,3.306,0,0,1-3.271-3.334V3.374c0-.031,0-.062,0-.093A3.305,3.305,0,0,1-13436.729,0h17.455A3.308,3.308,0,0,1-13416,3.3V16.667a3.308,3.308,0,0,1-3.273,3.334Zm-1.091-3.334a1.1,1.1,0,0,0,1.091,1.111h17.455a1.1,1.1,0,0,0,1.091-1.111V5.468l-9.191,6.553a1.069,1.069,0,0,1-.626.2,1.066,1.066,0,0,1-.625-.2l-9.194-6.554Zm9.819-6.911,9.7-6.919a1.092,1.092,0,0,0-.977-.615h-17.455a1.091,1.091,0,0,0-.975.615Z",
    transform: "translate(13440)",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.56c3c146b3eca171213b60cf152e73c2.svg";
export { ForwardRef as ReactComponent };